module.exports = __webpack_public_path__ + "static/media/human-ala.c2a0b5c0.png";